/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import NocNavBar from '../../../../layouts/noc/NocNavBar';
import Schedule from '../../../shared/noc/schedule/Schedule';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { NOC, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { VICE_PRESIDENT_FSE } from '../../../../../utils/config';

const NocSchedule = ({ history }) => {
  useCheckTwoDepartments(`${NOC}`,  `${VICE_PRESIDENT_FSE}`, `${SUPER_ADMIN}`, history);
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <NocNavBar currentPage="Night/Sunday" />
        <Schedule />
      </main>
    </div>
  );
};

NocSchedule.propTypes = {
  history: PropTypes.shape(),
};

export default NocSchedule;
